import type { HermesGuardFn } from '@/router/guards/types'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

const HESTIA_LOYALTY_ROUTES = new Set(['brand.apps.loyalty'])

export const checkHestiaLoyaltyFeatureFlag: HermesGuardFn = async (to) => {
  if (!HESTIA_LOYALTY_ROUTES.has(to.name as string)) return undefined

  const featureFlags = useFeatureFlags()

  if (!featureFlags.isEnabled('hermes.hestiaLoyalty')) {
    return {
      name: 'brand.customers',
      params: { brandId: to.params.brandId },
    }
  }

  return undefined
}
